module.exports = "/_next/static/images/0990d11cec30a68a55991ce693e9dce3-card-and-phone-3d-xs@3x.jpg.webp";